module.exports = __webpack_public_path__ + "img/已过期图章@3x.59bef30e.png";